import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { MultiUseTicketType } from '@kinderlabs-pos/shared-data-type';

export const useMutAsync =
	(rootUrl: string) =>
	async ({ storeId, posId, memberId, orderId, ticketId }: UseMutAsyncRequestType) =>
		(
			await posAxiosClient.post<MultiUseTicketType>(
				`${rootUrl}/ticket/mut/store/${storeId}/pos/${posId}/use`,
				{
					memberId,
					orderId,
				},
				{
					params: {
						ticketId,
					},
				}
			)
		).data;

export type UseMutAsyncRequestType = {
	ticketId: number;
	orderId: string;
	memberId: number;
	storeId: number;
	posId: number;
};
